const genApiGetRequest = (api, paramsRequest={}) => {
    return `${api}?${Object.keys(paramsRequest).map(item => `${item}=${paramsRequest[item]}`).join("&")}`
} 

export default genApiGetRequest